// src/utils/dateUtils.js

/**
 * Преобразует ISO-UTC строку (или Date) в строку для <input type="datetime-local">
 * в браузерной локальной таймзоне, вида "YYYY-MM-DDThh:mm"
 */
export function toInputLocal(dateUtc) {
    if (!dateUtc) return "";
    const date = typeof dateUtc === "string" ? new Date(dateUtc) : dateUtc;
    // убираем смещение в минутах, чтобы получить локальное время
    const tzOffsetMs = date.getTimezoneOffset() * 60000;
    const local = new Date(date.getTime() - tzOffsetMs);
    return local.toISOString().slice(0, 16);
  }
  
  /**
   * Преобразует строку из <input type="datetime-local"> (локальное время)
   * в ISO-UTC со суффиксом Z
   */
  export function fromInputLocalToUtcIso(inputValue) {
    if (!inputValue) return "";
    const localDate = new Date(inputValue);  // интерпретируется как локальное
    return localDate.toISOString();          // отдаёт UTC с Z
  }
  
  /**
   * Красиво форматирует ISO-UTC строку (или Date) в браузерной локальной таймзоне
   * в виде "DD.MM.YYYY hh:mm"
   */
  export function formatLocal(dateUtc) {
    if (!dateUtc) return "—";
    const date = typeof dateUtc === "string" ? new Date(dateUtc) : dateUtc;
    return date.toLocaleString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  }
  